import { useState, useEffect } from 'react';

export const TestimonialsSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const testimonials = [
    {
      name: 'أحمد محمد',
      location: 'الأفلاج',
      rating: 5,
      text: 'بفضل عيادة الإقلاع تمكنت من الإقلاع عن التدخين بعد 15 سنة. الفريق الطبي محترف جداً والمتابعة مستمرة. أنصح كل من يريد الإقلاع بالتواصل معهم.',
      image: 'https://public.readdy.ai/ai/img_res/bb09b870622a3ee9bb7d0d442da851ab.jpg'
    },
    {
      name: 'فاطمة العلي',
      location: 'الرياض',
      rating: 5,
      text: 'كان التدخين جزءاً من حياتي لسنوات طويلة، لكن بمساعدة الأطباء في عيادة الإقلاع وبرنامجهم الشامل، تمكنت من التخلص من هذه العادة نهائياً. شكراً لكم.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20middle%20aged%20Saudi%20Arabian%20woman%20wearing%20hijab%20smiling%20warmly%2C%20clean%20background%2C%20healthcare%20success%20story%2C%20positive%20attitude%2C%20medical%20consultation%20setting%2C%20hope%20and%20recovery%2C%20professional%20portrait%20style&width=100&height=100&seq=testimonial-002&orientation=squarish'
    },
    {
      name: 'خالد السعود',
      location: 'الخرج',
      rating: 5,
      text: 'الخدمة ممتازة والمتابعة الطبية على أعلى مستوى. دكتور محمد ساعدني كثيراً في وضع خطة مناسبة للإقلاع. الآن صحتي أفضل بكثير وأشعر بطاقة أكبر.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20young%20Saudi%20Arabian%20man%20smiling%20confidently%2C%20clean%20background%2C%20healthcare%20success%20story%2C%20positive%20attitude%2C%20medical%20consultation%20setting%2C%20hope%20and%20recovery%2C%20professional%20portrait%20style&width=100&height=100&seq=testimonial-003&orientation=squarish'
    },
    {
      name: 'سارة أحمد',
      location: 'الدمام',
      rating: 5,
      text: 'التطبيق سهل الاستخدام والدعم عبر الواتساب مفيد جداً. تمكنت من الإقلاع خلال شهرين فقط بفضل المتابعة المستمرة والدعم النفسي من الفريق.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20young%20Saudi%20Arabian%20woman%20wearing%20hijab%20smiling%20warmly%2C%20clean%20background%2C%20healthcare%20success%20story%2C%20positive%20attitude%2C%20medical%20consultation%20setting%2C%20hope%20and%20recovery%2C%20professional%20portrait%20style&width=100&height=100&seq=testimonial-004&orientation=squarish'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [testimonials.length]);

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16 animate-fade-in">
          <h3 className="text-4xl md:text-5xl font-bold text-primary mb-4">آراء المرضى</h3>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            اقرأ قصص النجاح من <strong>المرضى الذين تمكنوا من الإقلاع</strong> بمساعدة فريقنا الطبي
          </p>
          <div className="w-24 h-1 bg-accent mx-auto mt-4"></div>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-primary/5 to-secondary/5 p-8">
            <div 
              className="flex transition-transform duration-500 ease-in-out"
              style={{ transform: `translateX(${currentSlide * 100}%)` }}
            >
              {testimonials.map((testimonial, index) => (
                <div key={index} className="w-full flex-shrink-0 px-8">
                  <div className="text-center">
                    <div className="mb-6">
                      <img
                        src={testimonial.image}
                        alt={testimonial.name}
                        className="w-20 h-20 rounded-full mx-auto object-cover shadow-lg"
                      />
                    </div>
                    
                    <div className="flex justify-center mb-4">
                      {[...Array(testimonial.rating)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-accent text-xl mx-0.5"></i>
                      ))}
                    </div>
                    
                    <blockquote className="text-lg md:text-xl text-gray-700 leading-relaxed mb-6 italic">
                      "{testimonial.text}"
                    </blockquote>
                    
                    <div>
                      <h5 className="text-xl font-bold text-primary">{testimonial.name}</h5>
                      <p className="text-gray-600">{testimonial.location}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Navigation Dots */}
          <div className="flex justify-center mt-8 gap-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 cursor-pointer ${
                  currentSlide === index ? 'bg-primary' : 'bg-gray-300'
                }`}
              />
            ))}
          </div>

          {/* Navigation Arrows */}
          <div className="flex justify-center mt-6 gap-4">
            <button
              onClick={() => setCurrentSlide((prev) => (prev - 1 + testimonials.length) % testimonials.length)}
              className="w-12 h-12 bg-primary text-white rounded-full flex items-center justify-center hover:bg-primary-600 transition-colors duration-300 cursor-pointer"
            >
              <i className="ri-arrow-right-line text-xl"></i>
            </button>
            <button
              onClick={() => setCurrentSlide((prev) => (prev + 1) % testimonials.length)}
              className="w-12 h-12 bg-primary text-white rounded-full flex items-center justify-center hover:bg-primary-600 transition-colors duration-300 cursor-pointer"
            >
              <i className="ri-arrow-left-line text-xl"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};